import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import SelectWrap from '../../../../components/SelectWrap';
import countries from '../../../../data/countries';

class Form extends Component {
    constructor(props) {
        super(props);

        this.state = {
            countries: []
        };

        this.handleFieldChange = this.handleFieldChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    handleFieldChange(event) {
        const { value,name } = event.target;

        this.setState({
            [name]: value
        });
    }

    handleFormSubmit(e) {
        e.preventDefault();

        this.props.onSubmit(this.state);
    }

    render() {
        return (
            <form onSubmit={this.handleFormSubmit}>
                <SelectWrap
                    values={countries}
                    label="Countries:"
                    name="countries"
                    onChange={this.handleFieldChange}
                    value={this.state.countries}
                    multi
                    required
                />
                <Button type="submit" bsStyle="info" className="m-b-15" >Apply</Button>
            </form>
        );
    }
}

export default Form;


// WEBPACK FOOTER //
// ./src/scenes/BidderCpc/components/Form/index.js